import { defineMutators } from "@rocicorp/zero"

import { agentRecommendationMutators } from "./mutators/agent-recommendations"
import { aiChatSessionMutators } from "./mutators/ai-chat-sessions"
import { aiChatSettingsMutators } from "./mutators/ai-chat-settings"
import { blockedSenderMutators } from "./mutators/blocked-senders"
import { changelogTagMutators } from "./mutators/changelog-tags"
import { changelogMutators } from "./mutators/changelogs"
import { chatMessageMutators } from "./mutators/chat-messages"
import { commentMutators } from "./mutators/comments"
import { companyMutators } from "./mutators/companies"
import { contactMutators } from "./mutators/contacts"
import { customViewMutators } from "./mutators/custom-views"
import { emailSettingsMutators } from "./mutators/email-settings"
import { emailMutators } from "./mutators/emails"
import { forwardedEmailIgnoreSenderMutators } from "./mutators/forwarded-email-ignore-senders"
import { githubSettingsMutators } from "./mutators/github-settings"
import { helpCenterArticleMutators } from "./mutators/help-center-articles"
import { helpCenterCustomHomeSectionMutators } from "./mutators/help-center-custom-home-sections"
import { helpCenterGroupMutators } from "./mutators/help-center-groups"
import { helpCenterProposalGroupMutators } from "./mutators/help-center-proposal-groups"
import { helpCenterArticleProposalMutators } from "./mutators/help-center-proposals"
import { helpCenterTabMutators } from "./mutators/help-center-tabs"
import { issueMutators } from "./mutators/issues"
import { liveChatMessageMutators } from "./mutators/live-chat-messages"
import { membershipMutators } from "./mutators/memberships"
import { messageReactionMutators } from "./mutators/message-reactions"
import { noteTemplateMutators } from "./mutators/note-templates"
import {
	notificationMutators,
	notificationPreferenceMutators,
	notificationSubscriptionMutators,
} from "./mutators/notifications"
import { personalSlackNotificationSettingsMutators } from "./mutators/personal-slack-notification-settings"
import { portalInstanceMutators } from "./mutators/portal-instances"
import { projectMutators } from "./mutators/projects"
import { recordingMutators } from "./mutators/recordings"
import { segmentMutators } from "./mutators/segments"
import { sidebarSectionMutators } from "./mutators/sidebar-sections"
import { slaPolicyMutators } from "./mutators/sla-policies"
import { slackChannelsMutators } from "./mutators/slack-channels"
import { slackConnectSettingsMutators } from "./mutators/slack-connect-settings"
import { slackMessageMutators } from "./mutators/slack-messages"
import { snippetFolderMutators } from "./mutators/snippet-folders"
import { snippetMutators } from "./mutators/snippets"
import { suggestionMutators } from "./mutators/suggestions"
import { tagGroupMutators } from "./mutators/tag-groups"
import { tagMutators } from "./mutators/tags"
import { teamsSettingsMutators } from "./mutators/teams-settings"
import { threadMutators } from "./mutators/threads"
import {
	aiChatSettingsTranslationMutators,
	changelogTranslationMutators,
	helpCenterArticleTranslationMutators,
	helpCenterGroupTranslationMutators,
	helpCenterHomeTranslationMutators,
	issueTranslationMutators,
	projectTranslationMutators,
} from "./mutators/translations"
import { userMutators } from "./mutators/users"
import { utteranceMutators } from "./mutators/utterances"
import { videoMutators } from "./mutators/videos"
import { widgetContactAvatarMutators } from "./mutators/widget-contact-avatars"
import { widgetLinkMutators } from "./mutators/widget-links"
import { widgetSettingsMutators } from "./mutators/widget-settings"
import { workspaceMutators } from "./mutators/workspaces"

export const mutators = defineMutators({
	tags: tagMutators,
	tagGroups: tagGroupMutators,
	comments: commentMutators,
	companies: companyMutators,
	helpCenterGroups: helpCenterGroupMutators,
	helpCenterTabs: helpCenterTabMutators,
	helpCenterArticles: helpCenterArticleMutators,
	helpCenterCustomHomeSections: helpCenterCustomHomeSectionMutators,
	helpCenterArticleProposals: helpCenterArticleProposalMutators,
	helpCenterProposalGroups: helpCenterProposalGroupMutators,
	blockedSenders: blockedSenderMutators,
	forwardedEmailIgnoreSenders: forwardedEmailIgnoreSenderMutators,
	emailSettings: emailSettingsMutators,
	chatMessages: chatMessageMutators,
	changelogs: changelogMutators,
	changelogTags: changelogTagMutators,
	contacts: contactMutators,
	emails: emailMutators,
	issues: issueMutators,
	projects: projectMutators,
	noteTemplates: noteTemplateMutators,
	recordings: recordingMutators,
	widgetSettings: widgetSettingsMutators,
	widgetLinks: widgetLinkMutators,
	widgetContactAvatars: widgetContactAvatarMutators,
	segments: segmentMutators,
	snippets: snippetMutators,
	snippetFolders: snippetFolderMutators,
	slaPolicies: slaPolicyMutators,
	sidebarSections: sidebarSectionMutators,
	customViews: customViewMutators,
	threads: threadMutators,
	utterances: utteranceMutators,
	videos: videoMutators,
	workspaces: workspaceMutators,
	slackMessages: slackMessageMutators,
	messageReactions: messageReactionMutators,
	liveChatMessages: liveChatMessageMutators,
	aiChatSettings: aiChatSettingsMutators,
	agentRecommendations: agentRecommendationMutators,
	suggestions: suggestionMutators,
	aiChatSessions: aiChatSessionMutators,
	slackConnectSettings: slackConnectSettingsMutators,
	slackChannels: slackChannelsMutators,
	teamsSettings: teamsSettingsMutators,
	githubSettings: githubSettingsMutators,
	users: userMutators,
	personalSlackNotificationSettings: personalSlackNotificationSettingsMutators,
	notifications: notificationMutators,
	notificationSubscriptions: notificationSubscriptionMutators,
	notificationPreferences: notificationPreferenceMutators,
	portalInstances: portalInstanceMutators,
	memberships: membershipMutators,
	issueTranslations: issueTranslationMutators,
	projectTranslations: projectTranslationMutators,
	changelogTranslations: changelogTranslationMutators,
	helpCenterArticleTranslations: helpCenterArticleTranslationMutators,
	helpCenterGroupTranslations: helpCenterGroupTranslationMutators,
	helpCenterHomeTranslations: helpCenterHomeTranslationMutators,
	aiChatSettingsTranslations: aiChatSettingsTranslationMutators,
})

export type Mutators = typeof mutators
export type ClientMutators = typeof mutators
